import React from 'react';
import parse from 'html-react-parser';

export default function SectionHeading({
  title,
  subTitle,
  variantColor,
  variant,
}) {
  return (
    <div className="cs_section_heading cs_style_1 text-center">
      <p className="text-accent text-[18px] leading-[1.625em] mb-0">
        {subTitle}
      </p>
      <div className="h-[10px] max-[991px]:h-[5px]" />
      <h2 className="text-[50px] leading-[1.3em] text-gray-900 mb-0 max-[1400px]:text-[46px] max-[1199px]:text-[40px] max-[991px]:text-[36px] max-[991px]:[br]:hidden">
        {parse(title)}
      </h2>
    </div>
  );
}
